import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function PlusLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute top-20 left-1/4 w-96 h-96 bg-sky-400/5 rounded-full blur-3xl" />
      <div className="w-full max-w-md relative">
        <div className="text-center mb-10">
          <Star className="w-16 h-16 text-sky-400 fill-sky-400 mx-auto mb-4" />
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter text-white">
            PUNTO STELLA <span className="text-sky-400">PLUS</span>
          </h1>
          <p className="text-zinc-500 mt-2 text-lg">Accesso operatore</p>
        </div>
        <form onSubmit={submit} className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 space-y-5">
          <div>
            <label className="block text-sm text-zinc-400 mb-2">Email</label>
            <input
              data-testid="plus-login-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              autoCapitalize="none" autoCorrect="off" spellCheck="false"
              className="w-full h-14 px-5 rounded-2xl bg-zinc-800 border border-zinc-700 text-white text-lg focus:outline-none focus:border-sky-400 transition-colors"
              placeholder="operatore@puntostella.it"
            />
          </div>
          <div>
            <label className="block text-sm text-zinc-400 mb-2">Password</label>
            <input
              data-testid="plus-login-password"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full h-14 px-5 rounded-2xl bg-zinc-800 border border-zinc-700 text-white text-lg focus:outline-none focus:border-sky-400 transition-colors"
              placeholder="••••••••"
            />
          </div>
          {error && <div data-testid="plus-login-error" className="text-red-400 text-sm bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3">{error}</div>}
          <button
            data-testid="plus-login-submit"
            type="submit" disabled={loading}
            className="w-full h-16 rounded-2xl bg-sky-500 hover:bg-sky-400 text-white font-display font-bold text-2xl flex items-center justify-center gap-3 disabled:opacity-60 transition-colors"
          >
            {loading ? <Loader2 className="w-6 h-6 animate-spin" /> : <Star className="w-6 h-6 fill-current" />}
            Accedi
          </button>
        </form>
      </div>
    </div>
  );
}
